Object.tsEntries = Object.entries.bind(Object);
Object.tsKeys = Object.keys.bind(Object);
